import { useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import useChartSeries from '@/components/Chart/hooks/useChartSeries';
import { TABLE_ROW_HEIGHT_PX } from '@/constants/constants';
import useUserDetails from '@/hooks/useUserDetails';
import { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';
import { RootState } from '@/store';

const useDhChart = (isSummary?: boolean) => {
  const calculateChartHeight = useCallback((): number => {
    const VIEWPORT_HEIGHT = window.innerHeight;
    const EXTRA_PADDING = isSummary ? 540 : 330;
    return Math.floor((VIEWPORT_HEIGHT - EXTRA_PADDING) / TABLE_ROW_HEIGHT_PX);
  }, [isSummary]);
  const { isUserPremium, isUserExpired } = useUserDetails();
  const { dataHubs, activeDataHubId } = useSelector((state: RootState) => state.dataHub);
  const dataHubSymbols = dataHubs.find(dataHub => dataHub.id === activeDataHubId)?.symbols || [];

  const [chartHeight, setChartHeight] = useState(calculateChartHeight());
  const [templateChartSeries, setTemplateChartSeries] = useState<TemplateChartSeries[]>();

  useEffect(() => {
    if (isUserExpired) {
      return;
    }
    if (isUserPremium) {
      const templateSeries: TemplateChartSeries[] = dataHubSymbols.length
        ? dataHubSymbols.toReversed().map(key => ({
            settings: { type: 'line' as const },
            symbol: {
              key,
              group: 'Prod_Indexes'
            }
          }))
        : [];
      setTemplateChartSeries(templateSeries.slice(0, isSummary ? 4 : 6));
    }
  }, [isUserPremium, activeDataHubId, dataHubSymbols, isUserExpired]);

  useEffect(() => {
    const handleResize = () => {
      setChartHeight(calculateChartHeight());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const { chartSeries, error, loading } = useChartSeries(templateChartSeries, true, isSummary);

  return { chartSeries, error, loading, chartHeight };
};
export default useDhChart;
